declare var hibachiConfig;
declare var angular;

class AddBookModalController {
	
	public contentModule : any;
	public lesson : any;
	public lessonId : string;
	public portfolioPageId : string;
	
	public isLoading = false;
	
	public keywords:string;

	public bookList : Array<any>=[];
	public bookLessons:any={
		totalPages:0,
		currentPage:1,
		pageShow:6
	}
	
	public selectedBook:any;
	public position;
	
	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	// @ngInject
	constructor(
		public $timeout,
		public $element,
		public contentService, 
		public imageService,
		public ModalService,
		public observerService,
		private apiService
	){}
	
	public $onInit = () => {

		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;

		this.getBookList();
		
		if(this.contentModule != null){
			
		} else {
			this.contentModule = this.contentService.newContentModule('cmtBook', this.position);
		}

		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}
	
	public getBookList = () =>{
		this.isLoading = true
		this.apiService.request('davisdigital:api.getBooksForAccount')
		.then(({data})=>{
			if(data.data && data.data.length){
				for(let book of data.data){
					let bookListBook = {};

					if( book.studentEdition ){
						book.name = book.title + ' (Student Book)';
						book.value = book.studentEdition.bookID;
						this.bookList.push({...book});
					}
					
					if( book.teacherEdition ){
						book.name = book.title + ' (Teacher Edition)';
						book.value = book.teacherEdition.bookID;
						this.bookList.push(book);
					}
				}
				
				this.bookList.splice(0, 0, {name:'-- All Books',value:null});
			}
			if(this.bookList.length){
				this.selectedBook = this.bookList[0];
				this.search();
			}
		}).finally(()=>{
			this.isLoading = false;
		})
	}
	
	public keywordSearch(){
		this.bookLessons.keywords = this.keywords;
		this.search(1);
	}
	
	public search = ( pageNumber?:number) =>{
		this.isLoading = true;
		
		if(pageNumber){
			this.bookLessons.currentPage = pageNumber;
		}
		var args:any = {
			bookID:this.selectedBook.value,
			currentPage:this.bookLessons.currentPage,
			pageShow:this.bookLessons.pageShow
		};

		if(this.bookLessons.keywords?.length){
			args.keywords = this.bookLessons.keywords;
		}
		
		this.apiService.request('davisdigital:api.getBookLessonsForAccount',args)
		.then(({data})=>{
			if(data?.data){
				
				var result = data.data;
				
				
				for(var i=0; i<result['bookLessons'].length; i++){
					
					var bookLesson = result['bookLessons'][i]; 
					if(bookLesson['keywords']){
						var keywords = bookLesson['keywords'].split(',');
					
						bookLesson['keywords'] = keywords.join(', ');
					}
				}
				
				this.bookLessons.totalPages = result.totalPages;
				this.bookLessons.records = result.bookLessons;
			}
		}).finally(()=>{
			this.isLoading = false;
		});
	}
	
	public launchBookPreview = ( bookLesson ) =>{
		this.ModalService.showModal({
			component: 'bookPreview',
			bodyClass: 'angular-modal-service-active',
			bindings: {
                bookID : bookLesson.book_bookID,
                pageNumber : bookLesson.pageNumber,
                previewFlag: true
			},
			preClose: (modal) => {
				modal.element.modal('hide');
				this.ModalService.closeModals();
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public save = (bookLesson:any) =>{
		
		this.contentModule.title = bookLesson.title;
		this.contentModule.bookLesson = {
			bookLessonID: bookLesson.bookLessonID
		}
		this.contentModule.bookLesson_book_bookID = this.selectedBook.value;
		this.contentModule.bookLesson_pageNumber = bookLesson.pageNumber
		
		this.contentModule.bodyHTML = `
			<h2>${bookLesson.book_title}</h2>
            <h3>${bookLesson.title}</h3>
          `
        if(bookLesson.essentialQuestions != null && bookLesson.essentialQuestions.trim().length ){
        	
        	this.contentModule.bodyHTML += `
        		<p><strong>Essential Questions: </strong>${bookLesson.essentialQuestions || ''}</p>
        	`
        
        }
        if((bookLesson.objective != null && bookLesson.objective.trim().length > 0) || (bookLesson.objectives != null && bookLesson.objectives.trim().length > 0)){
        	this.contentModule.bodyHTML += `
        		<p><strong>Objective: </strong>${bookLesson.objectives || bookLesson.objective || ''}</p>
        	`
        }
        if((bookLesson.materials != null && bookLesson.materials.trim().length > 0) || (bookLesson.material != null && bookLesson.material.trim().length > 0)){
        	this.contentModule.bodyHTML += `
        		<p><strong>Materials: </strong>${bookLesson.materials || bookLesson.material || ''}</p>
        	`
        }

        if(bookLesson.interdisciplinaryConnections != null && bookLesson.interdisciplinaryConnections.trim().length > 0){
        	this.contentModule.bodyHTML += `
        		<p><strong>Interdisciplinary Connections: </strong>${bookLesson.interdisciplinaryConnections || ''}</p>
        	`
        }
        if(bookLesson.theme != null && bookLesson.theme.trim().length > 0){
        	this.contentModule.bodyHTML += `
        		<p><strong>Theme: </strong>${bookLesson.theme || ''}</p>
        	`
        }
        if(bookLesson.vocabulary != null && bookLesson.vocabulary.trim().length > 0){
        	this.contentModule.bodyHTML += `
        		<p><strong>Vocabulary: </strong>${bookLesson.vocabulary || ''}</p>
        	`
        }
         
		if(bookLesson.keywords.trim().length){ 
			this.contentModule.bodyHTML += `   
				<p><strong>Keywords: </strong>${bookLesson.keywords || ''}</p>
			`;
		}

        
		var eventName = 'updateContent';
	
		if( !this.contentModule.contentModuleID || 
			 this.contentModule.contentModuleID.length !== 32
		){
			eventName = 'addContent';
		}
		
		let notifyId = this.lessonId?.length ? this.lessonId : this.portfolioPageId;
		if( 'undefined' != typeof notifyId){
			this.observerService.notifyById( eventName, notifyId, this.contentModule);
		}else{
		 	this.observerService.notify(eventName, this.contentModule);
		}
		
		this.close();
	}
	
	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}

	public close = () =>{
		this.ModalService.closeModals();

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
	}

}

class AddBookModal {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPageId:'=?',
		position:'='
	};

	public controller = AddBookModalController;
	public controllerAs = 'addBookModal';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/add-book-modal.html';
	}
}

export { AddBookModal };
